<template>
  <div class="container">
    <div class="dialog">
      <div class="dialog-mask">
        <div class="edit-job">
          <div class="job-box">
            <div class="box-header">
              <h2 class="title">{{ title }}</h2>
              <button type="button" class="header-modal-close" aria-label="关闭职位编辑弹窗" @click.stop.prevent="close">
                <i class="el-icon-close" aria-hidden="true"></i>
              </button>
            </div>
            <div class="section-main">
              <div class="tab-bar">
                <!-- 第一个标签，点击切换激活状态 -->
                <div class="tab-item" :class="{ active: currentTab === 'basic' }" @click="currentTab = 'basic'"
                  style="margin-right: 5px;">
                  招呼设置
                </div>
                <!-- 第二个标签 -->
                <div class="tab-item" :class="{ active: currentTab === 'filter' }" @click="currentTab = 'filter'">
                  回复设置
                </div>
                <div class="tab-item" :class="{ active: currentTab === 'again' }" @click="currentTab = 'again'">
                  复聊设置
                </div>
              </div>
              <div class="tab-box" v-if="currentTab === 'basic'">
                <div class="section" v-if="this.name !== 'Edit'">
                  <h3 class="section-title">拷贝招呼数据</h3>
                  <div class="copy-data-box">
                    <div class="search-input-wrapper">
                      <input type="text" v-model="shareID" placeholder="输入职位ID查看分享数据" class="search-input"
                        @keyup.enter="searchJobById" />
                      <button class="search-btn" @click="searchJobById">
                        <i class="el-icon-search"></i>
                      </button>
                    </div>
                    <el-select v-model="hisData" placeholder="请选择需要拷贝的职位" size="small" @change="gethistoryData"
                      @visible-change="showhisData" clearable>
                      <el-option v-for="item in hisJobs" :key="item.ZLid"
                        :label="item.positionName + '-' + item.positionCity" :value="item.ZLid">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">筛选条件</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">年龄范围</div>
                        <div class="value ages">
                          <div class="unit-input"><input maxlength="2" type="text" v-model="post.minAge"
                              placeholder="min" /><span>岁</span></div>
                          <span>—</span>
                          <div class="unit-input"><input maxlength="2" type="text" v-model="post.maxAge"
                              placeholder="max" /><span>岁</span></div>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">性别要求</div>
                        <div class="value">
                          <el-radio-group v-model="post.gender">
                            <el-radio :label="2">不限</el-radio>
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="0">女</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">人才范围</div>
                        <div class="value">
                          <el-checkbox-group v-model="talentScopes" @change="talentScopeChange">
                            <el-checkbox label="不限" @click.native="handTalentScopeClick"></el-checkbox>
                            <el-checkbox label="过滤我已看过"></el-checkbox>
                            <el-checkbox label="过滤同事已聊"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">学历要求</div>
                        <div class="value">
                          <el-checkbox-group v-model="eduRequires" @change="eduReqChange">
                            <el-checkbox label="不限" @click.native="handeduReqClick"></el-checkbox>
                            <el-checkbox label="中专"></el-checkbox>
                            <el-checkbox label="高中"></el-checkbox>
                            <el-checkbox label="大专"></el-checkbox>
                            <el-checkbox label="本科"></el-checkbox>
                            <el-checkbox label="硕士"></el-checkbox>
                            <el-checkbox label="博士"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">活跃条件</div>
                        <div class="value active">
                          <el-radio-group v-model="post.activeCondi">
                            <el-radio :label="0">不限</el-radio>
                            <el-radio :label="1">今日活跃</el-radio>
                            <el-radio :label="2">3天内活跃</el-radio>
                            <el-radio :label="3">7天内活跃</el-radio>
                            <el-radio :label="4">30天内活跃</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">学历性质</div>
                        <div class="value edu">
                          <el-checkbox-group v-model="collegeRequires" @change="collegeChange">
                            <el-checkbox label="不限" @click.native="handleUnlimitedClick"></el-checkbox>
                            <el-checkbox label="统招"></el-checkbox>
                            <el-checkbox label="985"></el-checkbox>
                            <el-checkbox label="211"></el-checkbox>
                            <el-checkbox label="双一流"></el-checkbox>
                            <el-checkbox label="海外院校"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">求职状态</div>
                        <div class="value active">
                          <el-radio-group v-model="post.jobIntention">
                            <el-radio :label="0">不限</el-radio>
                            <el-radio :label="1">离职-找工作</el-radio>
                            <el-radio :label="2">在职-不找工作</el-radio>
                            <el-radio :label="3">在职-看机会</el-radio>
                            <el-radio :label="4">在职-找工作</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">经验要求</div>
                        <div class="value edu">
                          <el-checkbox-group v-model="expRequires" @change="expChange">
                            <el-checkbox label="不限" @click.native="handexpReqClick"></el-checkbox>
                            <el-checkbox label="26年毕业"></el-checkbox>
                            <el-checkbox label="27年毕业"></el-checkbox>
                            <el-checkbox label="1年以下"></el-checkbox>
                            <el-checkbox label="1-3年"></el-checkbox>
                            <el-checkbox label="3-5年"></el-checkbox>
                            <el-checkbox label="5-10年"></el-checkbox>
                            <el-checkbox label="10年以上"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">基础信息</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">发布职位名称
                          <el-tooltip class="item" effect="dark" content="名称须跟发布职位名称一致" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <input type="text" v-model="post.positionName" placeholder="请输入发布职位名称" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">发布职位城市
                          <el-tooltip class="item" effect="dark" content="请输入发布职位的城市" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <input type="text" v-model="post.positionCity" placeholder="请输入发布职位的城市" />
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">每日招呼数量
                          <el-tooltip class="item" effect="dark" content="设置该职位每日上限招呼数量，不设置则无限" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <div class="unit-input"><input maxlength="3" type="text" v-model="post.recruitNum"
                              placeholder="请输入打招呼数量" /><span>个</span></div>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">工作岗位名称
                          <el-tooltip class="item" effect="dark" content="匹配人选工作岗位名称" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <input type="text" v-model="post.jobName" placeholder="请输入工作岗位名称" />
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">胜任分数
                          <el-tooltip class="item" effect="dark" content="岗位胜任要求符合分数" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <div class="unit-input"><input maxlength="2" v-model="post.recruitScore" type="text"
                              placeholder="请输入匹配分数，满分100" /><span>分</span></div>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">淘汰分数
                          <el-tooltip class="item" effect="dark" content="不符合胜任分数点击不合适" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <div class="unit-input"><input maxlength="2" type="text" v-model="post.mismatchScore"
                              placeholder="请输入低于多少分，点击不合适" /><span>分</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">薪资范围
                          <el-tooltip class="item" effect="dark" content="输入薪资金额，不用带K" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value ages salary-range">
                          <div class="salary-input"><input maxlength="2" type="text" v-model="post.minSalary"
                              placeholder="min" /><span>K</span></div>
                          <span>—</span>
                          <div class="salary-input"><input maxlength="3" type="text" v-model="post.maxSalary"
                              placeholder="max" /><span>K</span></div>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">仅沟通在线人选</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.onLineGreet">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">简历关键词检索
                    <el-switch style="margin-left:10px" v-model="post.keyType" active-text="全部词" inactive-text="任意词">
                    </el-switch>
                    <el-switch style="margin-left:20px" v-model="post.resumeType" active-text="匹配最近三段"
                      inactive-text="匹配所有信息">
                    </el-switch>
                  </h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="keyInput" class="tag-input" placeholder="输入关键词后按回车添加" @keyup.enter="addKey" />
                      <button class="add-btn" @click="addKey">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in keywords" closable :disable-transitions="false"
                        @close="removeKey(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">
                    <span>学校专业检索</span>
                    <el-switch style="margin-left:10px" v-model="post.MajorType" active-text="与关键词且的关系"
                      inactive-text="与关键词或的关系">
                    </el-switch>
                  </h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="MajorInput" class="tag-input" placeholder="输入专业名称后按回车添加"
                        @keyup.enter="addMajor" />
                      <button class="add-btn" @click="addMajor">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in majorwords" closable :disable-transitions="false"
                        @close="removeMajor(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">目标公司检索</h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="mbInput" class="tag-input" placeholder="输入目标公司后按回车添加" @keyup.enter="addMb" />
                      <button class="add-btn" @click="addMb">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in contains" closable :disable-transitions="false"
                        @close="removeMb(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">过滤公司检索</h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="glInput" class="tag-input" placeholder="输入过滤公司后按回车添加" @keyup.enter="addGl" />
                      <button class="add-btn" @click="addGl">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in filters" closable :disable-transitions="false"
                        @close="removeGl(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section" v-if="AIRoom !== '无AI'">
                  <h3 class="section-title">岗位胜任要求</h3>
                  <div class="job-desc">
                    <textarea v-model="post.jobDesc"></textarea>
                  </div>
                </div>
              </div>
              <div class="tab-box" v-else-if="currentTab === 'filter'">
                <div class="section">
                  <h3 class="section-title">基础功能设置</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">AI自动回复</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AIChat">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">AI请求简历</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AIreqRes">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">AI请求微信</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AichangeWx">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">聊天起止时间</div>
                        <div class="value chatTime">
                          <el-time-select size="small" placeholder="起始时间" v-model="post.AIChatstartTime"
                            :picker-options="{
                              start: '08:00',
                              step: '00:30',
                              end: '18:30'
                            }">
                          </el-time-select>
                          <span>—</span>
                          <el-time-select size="small" placeholder="结束时间" v-model="post.AIChatendTime" :picker-options="{
                            start: '08:00',
                            step: '00:30',
                            end: '23:30',
                            minTime: post.AIChatstartTime
                          }">
                          </el-time-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section" v-if="AIType < 5">
                  <div class="section-title">知识库配置</div>
                  <div style="margin-bottom: 10px;" v-if="this.name !== 'Edit'">
                    <el-select v-model="hishfData" placeholder="请选择需要拷贝的职位" size="small" @change="gethfhistoryData"
                      @visible-change="showhisData">
                      <el-option v-for="item in hisJobs" :key="item.ZLid" :label="item.positionName" :value="item.ZLid">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box btm">
                        <div class="name">关键词内容 (多个内容用，分隔)</div>
                        <div class="value">
                          <input type="text" v-model="zskey" placeholder="请输入关键词内容" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">回复内容</div>
                        <div class="key-desc">
                          <textarea v-model="zsvalue"></textarea>
                        </div>
                      </div>
                      <div class="btn">
                        <button class="add-btn" v-if="title === '编辑职位'" @click="addKnow()">{{ zsbtn }}</button>
                      </div>
                    </div>
                    <div class="position-list">
                      <div class="position-item" v-for="(item, index) in keyList" :key="index">
                        <div class="item-box" style="overflow: hidden;">
                          <div class="position-info">
                            <span class="position-name">关键词：{{ item.key }}</span>
                            <div class="meta-info">
                              <span>内容: {{ item.value }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="action-btns" v-if="title === '编辑职位'">
                          <button class="edit-btn" @click="keyEdit(item.id, index)">编辑</button>
                          <button class="delete-btn" @click="keyDelete(item.id)">删除</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section" v-if="AIType >= 5">
                  <div class="section-title">AI回复知识库
                    <el-switch v-model="post.AIzskhf"></el-switch>
                  </div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box" style="margin-bottom:5px;">
                        <div class="key-desc">
                          <textarea style="height:120px" v-model="post.AIzsknr" placeholder="填写岗位基本信息，如工作时间、招聘要求、薪资待遇、工作地址等，AI助手会参照这些信息来解答求职者的问题。例：
                          工作时间：XXXXX；
                          岗位要求：XXXXX；
                          薪资待遇：XXXXX；"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title">首次消息设置</div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box" style="margin-bottom:5px;">
                        <div class="name">首次聊天回复</div>
                        <div class="key-desc">
                          <textarea v-model="post.firstChat"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="key-box-item">
                      <div class="item-box" style="margin-bottom:5px;">
                        <div class="name">简历不合适回复</div>
                        <div class="key-desc">
                          <textarea v-model="post.improperhf"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title">交换回复设置</div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box" style="margin-bottom:5px;">
                        <div class="name">交换简历后回复</div>
                        <div class="key-desc">
                          <textarea v-model="post.AiJlhf"></textarea>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">交换微信后回复</div>
                        <div class="key-desc">
                          <textarea v-model="post.AiWxhf"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section" v-if="false">
                  <h3 class="section-title">AI追问设置</h3>
                  <div class="section-box">
                    <div class="section-box-item key-box-item">
                      <div class="item-box xh tw">
                        <div class="name">追问序号</div>
                        <div class="value">
                          <input type="text" v-model="post.jobName" placeholder="请输入序号" />
                        </div>
                      </div>
                      <div class="item-box nr tw">
                        <div class="name">追问内容</div>
                        <div class="value">
                          <input type="text" v-model="post.jobName" placeholder="请输入提问内容" />
                        </div>
                      </div>
                    </div>
                    <div class="btn">
                      <button class="add-btn" v-if="title === '编辑职位'">添加</button>
                    </div>
                    <div class="position-list" v-if="title === '编辑职位'">
                      <div class="position-item" v-for="(item, index) in zwList" :key="index"
                        :class="clickIndex === index ? 'active' : ''" @click="activeHover(index, item.id)">
                        <div class="item-box">
                          <div class="position-info">
                            <span class="position-name">关键词：{{ item.positionName }}</span>
                            <div class="meta-info">
                              <span>内容: {{ item.recruitNum }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="action-btns">
                          <button class="edit-btn" @click="keyEdit(item.id)">编辑</button>
                          <button class="delete-btn" @click="keyDelete(item.id, index)">删除</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-box" v-else>
                <div class="section">
                  <h3 class="section-title">基础功能设置</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">复聊开始日期</div>
                        <div class="value chatTime">
                          <el-date-picker size="small" v-model="post.againStartDate" type="date" placeholder="选择日期"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                          </el-date-picker>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">复聊起止时间</div>
                        <div class="value chatTime">
                          <el-time-select size="small" placeholder="起始时间" v-model="post.againstartTime" :picker-options="{
                            start: '08:00',
                            step: '00:30',
                            end: '18:30'
                          }">
                          </el-time-select>
                          <span>—</span>
                          <el-time-select size="small" placeholder="结束时间" v-model="post.againendTime" :picker-options="{
                            start: '08:00',
                            step: '00:30',
                            end: '23:30',
                            minTime: post.againstartTime
                          }">
                          </el-time-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">复聊内容设置</h3>
                  <div style="margin-bottom: 10px;" v-if="this.name !== 'Edit'">
                    <el-select v-model="hisflData" placeholder="请选择需要拷贝的职位" size="small" @change="getflhistoryData"
                      @visible-change="showhisData">
                      <el-option v-for="item in hisJobs" :key="item.ZLid" :label="item.positionName" :value="item.ZLid">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="section-box">
                    <div class="section-box-item key-box-item">
                      <div class="item-box xh tw">
                        <div class="name">复聊次数</div>
                        <div class="value">
                          <input type="text" v-model="flNum" placeholder="例如 第1次" />
                        </div>
                      </div>
                      <div class="item-box nr tw">
                        <div class="name">复聊内容</div>
                        <div class="value">
                          <input type="text" v-model="flValue" placeholder="请输入复聊内容" />
                        </div>
                      </div>
                    </div>
                    <div class="btn">
                      <button class="add-btn" v-if="title === '编辑职位'" @click="addAgain()">{{ flbtn }}</button>
                    </div>
                    <div class="position-list">
                      <div class="position-item" v-for="(item, index) in flList" :key="index">
                        <div class="item-box">
                          <div class="position-info">
                            <span class="position-name">第{{ item.flNum }}次复聊</span>
                            <div class="meta-info">
                              <span>内容: {{ item.flValue }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="action-btns" v-if="title === '编辑职位'">
                          <button class="edit-btn" @click="againEdit(item.id, index)">编辑</button>
                          <button class="delete-btn" @click="againDelete(item.id)">删除</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer">
              <button class="share-btn" @click="shareJob" v-if="isShare"><i class="el-icon-share"></i> 分享职位</button>
              <button class="save-btn" @click="save">保存</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getZLJobList, createZLJob, updateZLJob, getZLJobInfo, addKnow, updateKnow, delKnow, getKnow, addAgain, updateAgain, delAgain, getAgain } from '@/request/api'
import dayjs from 'dayjs'
export default {
  props: {
    name: String,
    jobID: {
      type: Number,
      default: 0
    }
  },
  created() {
    if (!sessionStorage.getItem("LoginInfo")) {
      this.$message.error('请先登录！');
      return;
    }
    this.AIType = JSON.parse(sessionStorage.getItem("LoginInfo")).cardType;
    this.AIRoom = JSON.parse(sessionStorage.getItem("LoginInfo")).airoom;
    if (this.name === 'Edit') {
      this.title = '编辑职位'
      this.post.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
      this.EditPost.jobID = this.jobID;
      this.isShare = true;
      this.getJobInfo();
      this.getKeyList();
      this.getAgainList();
    } else {
      this.isShare = false;
      this.title = '新增职位'
      this.post.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
    }
  },
  data() {
    return {
      shareID: '',
      isShare: true,// 分享职位
      title: '编辑职位',
      currentTab: 'basic',
      Arr: {}, // 新结果
      keyInput: '',
      MajorInput: '',
      mbInput: '',
      glInput: '',
      zskey: '', // 知识库关键词
      zsvalue: '', // 知识库内容
      zsbtn: '添加',
      zsID: null,
      flNum: '第1次', // 复聊次数
      flValue: '', // 复聊内容
      flbtn: '添加',
      flID: null,
      choose: true,// 
      keywords: [],// 关键词
      majorwords: [],// 专业要求
      contains: [],// 目标公司
      filters: [],// 过滤公司
      clickIndex: null,
      collegeRequires: ['不限'], // 院校要求
      eduRequires: ['不限'], // 学历要求
      expRequires: ['不限'], // 经验要求
      talentScopes: ['不限'], // 人才范围
      keyList: [],
      zwList: [],
      flList: [],
      hisflData: '',
      hishfData: '',
      hisData: '',
      hisJobs: [],
      post: {
        username: '',
        minAge: '', // 最小年龄
        maxAge: '', // 最大年龄
        gender: 2, // 性别
        talentScope: '', // 人才范围
        eduRequire: '', // 学历要求
        activeCondi: 0, // 活跃条件
        collegeRequire: '', // 院校要求
        expRequire: '', // 经验要求
        jobIntention: 0, // 求职意向
        positionName: '', // 职位名称
        positionCity: '', // 职位城市
        recruitNum: '', // 招呼数量
        recruitScore: 88, // 胜任分数
        mismatchScore: 0, // 淘汰分数
        jobName: '', // 岗位名称
        jobDesc: '', // 职位描述
        keyType: false,// 关键词类型
        resumeType: false,// 匹配类型
        MajorType: false,// 专业类型
        minSalary: '', // 最低薪资
        maxSalary: '', // 最高薪资
        keyword: '', // 关键词
        majorword: '', // 专业词
        contain: '', // 包含公司
        filter: '', // 过滤公司
        onLineGreet: false, // 仅对在线人选打招呼
        AIChat: false, // AI聊天开关
        AIzskhf: false, // AI知识库回复
        AIzsknr: '', // AI知识库内容
        AIreqRes: true, // AI请求简历
        AichangeWx: false, // AI请求微信
        AIChatstartTime: '', //AI开始时间
        AIChatendTime: '', //AI结束时间
        againStartDate: '', //复聊开始日期
        againstartTime: '', //复聊开始时间
        againendTime: '', //复聊结束时间
        AiJlhf: '', // Ai求简历回复
        AiWxhf: '', // Ai微信回复
        firstChat: '您好，方便发一份简历吗', // 首次消息回复
        improperhf: '不好意思，不太合适哦', // 不合适回复
        channel: 2 // 渠道 
      },
      EditPost: {
        jobID: 0,
      }
    };
  },
  methods: {
    async shareJob() {
      const jobId = this.EditPost.jobID;
      const shareText = `ZL职位分享信息：\n岗位名：${this.post.positionName}\n职位ID：${jobId + 100000000}\n快来试试我的岗位数据吧~！`;
      try {
        await navigator.clipboard.writeText(shareText);
        this.$message.success('分享内容已复制到剪贴板');
      } catch (err) {
        // 降级方案：创建临时文本框
        const textarea = document.createElement('textarea');
        textarea.value = shareText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('分享内容已复制到剪贴板');
      }
    },
    // 搜索职位ID
    async searchJobById() {
      if (this.shareID === '') {
        this.$message.error('请输入职位ID');
        return;
      } else if (this.shareID.indexOf('ZL') === -1) {
        this.$message.error('请输入智联正确的职位ID');
        return;
      }
      this.shareID = this.shareID.replace(/[^\d]/g, '');
      this.EditPost.jobID = String(Number(this.shareID) - 100000000);
      this.getJobInfo('share');
    },
    getflhistoryData() {
      this.EditPost.jobID = this.hisflData;
      this.getAgainList();
    },
    gethfhistoryData() {
      this.EditPost.jobID = this.hishfData;
      this.getKeyList();
    },
    gethistoryData() {
      this.EditPost.jobID = this.hisData;
      this.getJobInfo('myself');
    },
    async showhisData(bool) {
      if (bool) {
        var { data: res } = await getZLJobList({ username: JSON.parse(sessionStorage.getItem("LoginInfo")).username });
        this.hisJobs = res.data;
      }
    },
    async getJobInfo(resType) {
      if (resType === 'share') {
        var { data: res } = await getZLJobInfo({ username: this.post.username, jobID: this.EditPost.jobID, resType: 'share' })
      } else {
        var { data: res } = await getZLJobInfo({ username: this.post.username, jobID: this.EditPost.jobID })
      }

      if (res.code === 200) {
        this.Arr = res.data;
        this.keywords = this.Arr.recruitKey?.includes(',') ? this.Arr.recruitKey.split(',') : this.Arr.recruitKey ? [this.Arr.recruitKey] : [];
        this.majorwords = this.Arr.recruitMajor?.includes(',') ? this.Arr.recruitMajor.split(',') : this.Arr.recruitMajor ? [this.Arr.recruitMajor] : [];
        this.filters = this.Arr.filterCom?.includes(',') ? this.Arr.filterCom.split(',') : this.Arr.filterCom ? [this.Arr.filterCom] : [];
        this.contains = this.Arr.containsCom?.includes(',') ? this.Arr.containsCom.split(',') : this.Arr.containsCom ? [this.Arr.containsCom] : [];
        this.collegeRequires = this.Arr.collegeRequire?.includes(',') ? this.Arr.collegeRequire.split(',') : [this.Arr.collegeRequire];
        this.eduRequires = this.Arr.eduRequire?.includes(',') ? this.Arr.eduRequire.split(',') : [this.Arr.eduRequire];
        this.expRequires = this.Arr.expRequire?.includes(',') ? this.Arr.expRequire.split(',') : [this.Arr.expRequire];
        this.post.minAge = this.Arr.minAge == 0 ? '' : this.Arr.minAge;
        this.post.maxAge = this.Arr.maxAge == 0 ? '' : this.Arr.maxAge;
        this.post.gender = this.Arr.gender;
        this.talentScopes = this.Arr.talentScope?.includes(',') ? this.Arr.talentScope.split(',') : [this.Arr.talentScope];
        this.post.eduRequire = this.Arr.eduRequire;
        this.post.activeCondi = this.Arr.activeCondi;
        this.post.jobIntention = this.Arr.jobIntention;
        this.post.positionName = this.Arr.positionName;
        this.post.positionCity = this.Arr.positionCity;
        this.post.recruitNum = this.Arr.recruitNum == 0 ? '' : this.Arr.recruitNum;
        this.post.recruitScore = this.Arr.recruitScore;
        this.post.mismatchScore = this.Arr.mismatchScore;
        this.post.jobName = this.Arr.jobName;
        this.post.jobDesc = this.Arr.recruitDesc;
        this.post.minSalary = this.Arr.minSalary == 0 ? '' : this.Arr.minSalary;;
        this.post.maxSalary = this.Arr.maxSalary == 0 ? '' : this.Arr.maxSalary;;
        this.post.onLineGreet = this.Arr.onLineGreet === 1 ? true : false;
        this.post.AIChat = this.Arr.aiSwitch === 1 ? true : false;
        this.post.AIzskhf = this.Arr.aizskhf === 1 ? true : false;
        this.post.AIzsknr = this.Arr.aizsknr;
        this.post.AIreqRes = this.Arr.aireqResume === 1 ? true : false;
        this.post.AichangeWx = this.Arr.aichangeWx === 1 ? true : false;
        this.post.keyType = this.Arr.keyType === 1 ? true : false;
        this.post.resumeType = this.Arr.resumeType === 1 ? true : false;
        this.post.MajorType = this.Arr.majorType === 1 ? true : false;
        this.post.AiJlhf = this.Arr.aijlhf;
        this.post.AiWxhf = this.Arr.aiwxhf;
        this.post.firstChat = this.Arr.aischf || '您好，方便发一份简历吗';
        this.post.improperhf = this.Arr.improperhf || '不好意思，不太合适哦';
        this.post.AIChatstartTime = this.Arr.aistartTime;
        this.post.AIChatendTime = this.Arr.aiendTime;
        this.post.againstartTime = this.Arr.flstartTime;
        this.post.againStartDate = this.Arr.flstartDate ? dayjs(this.Arr.flstartDate).format('YYYY-MM-DD') : ''
        this.post.againendTime = this.Arr.flendTime;
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
        return;
      }
    },
    close() {
      this.$emit('MessageClose')
    },
    collegeChange(val) {
      if (this.collegeRequires.length < 1) {
        this.collegeRequires = ['不限']
      } else {
        this.collegeRequires = val.filter(item => item !== '不限');
      }
    },
    talentScopeChange(val) {
      // 第一步：过滤掉空字符串，解决你的核心问题
      val = val.filter(item => item && item.trim() !== '');

      // 第二步：实现"不限"互斥逻辑
      if (val.includes('不限') && val.length > 1) {
        // 如果同时选中了"不限"和其他选项，则移除"不限"，只保留其他选项
        this.talentScopes = val.filter(item => item !== '不限');
      } else if (val.includes('不限')) {
        // 仅选了"不限" → 只保留不限，清空其他
        this.talentScopes = ['不限'];
      } else {
        // 没选"不限" → 正常赋值
        this.talentScopes = val.length ? val : ['不限'];
      }
    },
    eduReqChange(val) {
      // 第一步：过滤掉空字符串，解决你的核心问题
      val = val.filter(item => item && item.trim() !== '');

      // 第二步：实现"不限"互斥逻辑
      if (val.includes('不限') && val.length > 1) {
        // 如果同时选中了"不限"和其他选项，则移除"不限"，只保留其他选项
        this.eduRequires = val.filter(item => item !== '不限');
      } else if (val.includes('不限')) {
        // 仅选了"不限" → 只保留不限，清空其他
        this.eduRequires = ['不限'];
      } else {
        // 没选"不限" → 正常赋值
        this.eduRequires = val.length ? val : ['不限'];
      }
    },
    expChange(val) {
      // 第一步：过滤掉空字符串，解决你的核心问题
      val = val.filter(item => item && item.trim() !== '');
      // 第二步：实现"不限"互斥逻辑
      if (val.includes('不限') && val.length > 1) {
        // 如果同时选中了"不限"和其他选项，则移除"不限"，只保留其他选项
        this.expRequires = val.filter(item => item !== '不限');
      } else if (val.includes('不限')) {
        // 仅选了"不限" → 只保留不限，清空其他
        this.expRequires = ['不限'];
      } else {
        // 没选"不限" → 正常赋值
        this.expRequires = val.length ? val : ['不限'];
      }
    },
    handTalentScopeClick(event) {
      if (!this.talentScopes.includes('不限')) {
        this.talentScopes = ['不限'];
        event.stopPropagation();
      }
    },
    handleUnlimitedClick(event) {
      if (!this.collegeRequires.includes('不限')) {
        this.collegeRequires = ['不限'];
        event.stopPropagation();
      }
    },
    handeduReqClick(event) {
      // 当点击"不限"时，如果当前还有其他选项被选中，则清空所有选项再选中"不限"
      // 如果只有"不限"被选中，则清空"不限"让用户可以选择其他选项
      if (this.eduRequires.length === 1 && this.eduRequires[0] === '不限') {
        // 当前只有"不限"被选中，点击后清空所有选项
        this.eduRequires = [];
      } else {
        // 其他情况（可能有多个选项或没有选项）直接选中"不限"
        this.eduRequires = ['不限'];
      }
      event.stopPropagation();
    },
    handexpReqClick(event) {
      // 当点击"不限"时，如果当前还有其他选项被选中，则清空所有选项再选中"不限"
      // 如果只有"不限"被选中，则清空"不限"让用户可以选择其他选项
      if (this.expRequires.length === 1 && this.expRequires[0] === '不限') {
        // 当前只有"不限"被选中，点击后清空所有选项
        this.expRequires = [];
      } else {
        // 其他情况（可能有多个选项或没有选项）直接选中"不限"
        this.expRequires = ['不限'];
      }
      event.stopPropagation();
    },
    addKey() {
      if (this.keyInput.trim()) {
        this.keywords.push(this.keyInput.trim());
        this.keyInput = '';
      }
    },
    addMajor() {
      if (this.MajorInput.trim()) {
        this.majorwords.push(this.MajorInput.trim());
        this.MajorInput = '';
      }
    },
    addMb() {
      if (this.mbInput.trim()) {
        this.contains.push(this.mbInput.trim());
        this.mbInput = '';
      }
    },
    addGl() {
      if (this.glInput.trim()) {
        this.filters.push(this.glInput.trim());
        this.glInput = '';
      }
    },
    removeKey(index) {
      this.keywords.splice(index, 1);
    },
    removeMajor(index) {
      this.majorwords.splice(index, 1);
    },
    removeMb(index) {
      this.contains.splice(index, 1);
    },
    removeGl(index) {
      this.filters.splice(index, 1);
    },
    async save() {
      if (this.post.positionName == '' || this.post.positionName == null) {
        this.$message.warning('发布职位名称不能为空');
        return;
      }
      if (this.post.positionCity == '' || this.post.positionCity == null) {
        this.$message.warning('发布职位城市不能为空');
        return;
      }
      this.post.talentScope = this.talentScopes.length > 0 ? this.talentScopes.join(',') : '';
      this.post.keyword = this.keywords.length > 0 ? this.keywords.join(',') : '';
      this.post.majorword = this.majorwords.length > 0 ? this.majorwords.join(',') : '';
      this.post.contain = this.contains.length > 0 ? this.contains.join(',') : '';
      this.post.filter = this.filters.length > 0 ? this.filters.join(',') : '';
      this.post.collegeRequire = this.collegeRequires.length > 0 ? this.collegeRequires.join(',') : '';
      this.post.expRequire = this.expRequires.length > 0 ? this.expRequires.join(',') : '';
      this.post.eduRequire = this.eduRequires.length > 0 ? this.eduRequires.join(',') : '';
      if (this.name == 'Add') {
        const { data: res } = await createZLJob(this.post);
        if (res.code === 200) {
          if (this.flList.length > 0) {
            this.flList.forEach(async item => {
              await addAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: res.data, flNum: item.flNum, flValue: item.flValue, channel: 1 });
            })
          }
          if (this.keyList.length > 0) {
            this.keyList.forEach(async item => {
              await addKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: res.data, zskey: item.key, zsvalue: item.value, channel: 1 });
            })
          }
          this.$message.success('添加成功！');
        } else {
          this.$message.error(res.message);
        }
        this.$emit('AddClose')
      } else {
        const { data: res } = await updateZLJob({ ...this.post, ...this.EditPost });
        this.$emit('EditClose')
      }
    },
    async addKnow() {
      if (this.zsbtn === '添加') {
        var { data: res } = await addKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, zskey: this.zskey, zsvalue: this.zsvalue, channel: 2 });
        if (res.code === 200) {
          this.$message.success('添加成功！');
        } else {
          this.$message.error(res.message);
        }
      } else {
        var { data: res } = await updateKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, knowID: this.zsID, jobID: this.EditPost.jobID, zskey: this.zskey, zsvalue: this.zsvalue, channel: 2 });
        if (res.code === 200) {
          this.$message.success('修改成功！');
          this.zsbtn = '添加';
        } else {
          this.$message.error(res.message);
        }
      }
      this.getKeyList();
      this.zskey = '';
      this.zsvalue = '';
    },
    keyEdit(id, index) {
      this.zsbtn = '修改';
      this.zsID = id;
      this.zskey = this.keyList[index].key;
      this.zsvalue = this.keyList[index].value;
    },
    async keyDelete(id) {
      var { data: res } = await delKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, knowID: id, channel: 2 });
      this.keyList = res.data;
    },
    async getKeyList() {
      var { data: res } = await getKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, channel: 2 });
      this.keyList = res.data;
    },
    async addAgain() {
      if (this.flNum.indexOf('第') === -1 || this.flNum.indexOf('次') === -1) {
        this.$message.warning('复聊次数格式有误，正确格式：第1次');
        return;
      }
      if (this.flbtn === '添加') {
        var { data: res } = await addAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, flNum: this.flNum, flValue: this.flValue, channel: 2 });
      } else {
        var { data: res } = await updateAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, againID: this.flID, jobID: this.EditPost.jobID, flNum: this.flNum, flValue: this.flValue, channel: 2 });
        this.flbtn = '添加';
      }
      this.getAgainList();
      this.flNum = '';
      this.flValue = '';
    },
    againEdit(id, index) {
      this.flbtn = '修改';
      this.flID = id;
      this.flNum = "第" + this.flList[index].flNum + "次";
      this.flValue = this.flList[index].flValue;
    },
    async againDelete(id) {
      var { data: res } = await delAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, againID: id, channel: 2 });
      this.flList = res.data;
    },
    async getAgainList() {
      var { data: res } = await getAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, channel: 2 });
      this.flList = res.data;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  z-index: 1000;
}

.dialog-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(10, 16, 28, .58);
  backdrop-filter: blur(3px);
}

.edit-job {
  width: 80%;
  max-height: calc(100vh - 48px);
  overflow: hidden;
  border: 1px solid var(--border-hairline);
  border-radius: 16px;
  background: var(--bg-page);
  color: var(--text-primary);
  box-shadow: var(--shadow-pop);
  animation: dialog-in .2s ease-out;
}

@keyframes dialog-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(.99);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.job-box {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  min-height: 0;
}

.box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  min-height: 62px;
  padding: 0 22px;
  border-bottom: 1px solid var(--divider);
  background: var(--bg-card);

  .title {
    margin: 0;
    color: var(--text-primary);
    font-size: 17px;
    font-weight: 650;
  }

  .header-modal-close {
    display: grid;
    place-items: center;
    flex: 0 0 32px;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: var(--text-secondary);
    font: inherit;
    cursor: pointer;
    transition: color .16s ease, background .16s ease;
  }

  .header-modal-close i {
    pointer-events: none;
  }

  .header-modal-close:hover {
    color: var(--text-primary);
    background: var(--bg-hover);
  }
}

.section-main {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0px 22px 24px;
  scrollbar-width: thin;
  scrollbar-color: var(--border-hairline) transparent;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: var(--border-hairline);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--text-secondary);
  }
}

.tab-bar {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  gap: 5px;
  margin: -18px -22px 18px;
  padding: 12px 22px 0;
  border-bottom: 1px solid var(--divider);
  background: var(--bg-page);
}

.tab-item {
  position: relative;
  min-width: 92px;
  padding: 11px 14px 12px;
  border-radius: 8px 8px 0 0;
  color: var(--text-secondary);
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  transition: color .16s ease, background .16s ease;

  &:hover {
    color: var(--text-primary);
    background: var(--bg-hover);
  }

  &.active {
    color: var(--brand);
    font-weight: 600;
    background: var(--bg-active);
  }

  &.active::after {
    position: absolute;
    right: 12px;
    bottom: -1px;
    left: 12px;
    height: 2px;
    border-radius: 2px;
    background: var(--brand);
    content: '';
  }
}

.tab-box {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 30px;
}

.section {
  min-width: 0;
  padding: 17px 18px;
  border: 1px solid var(--border-hairline);
  border-radius: 12px;
  background: var(--bg-card);
  box-shadow: var(--shadow-card);
}

html.dark .section {
  border-color: rgba(177, 194, 216, .1);
  background: #182231;
}

html.dark .item-box,
html.dark .copy-data-box {
  border-color: rgba(255, 255, 255, .035);
  background: #303a4a;
}

html.dark .section-title {
  color: #e0e6ef;
}

html.dark .name {
  color: #e0e6ef;
}

html.dark .value {
  color: #c6cfdd;
}

html.dark .value input,
html.dark .value textarea,
html.dark .key-desc textarea,
html.dark .greet-desc textarea,
html.dark .job-desc textarea,
html.dark .tag-input,
html.dark .copy-data-box .search-input {
  border-color: rgba(255, 255, 255, .07);
  background: rgba(17, 25, 37, .42);
  color: #e0e6ef;
}

html.dark ::v-deep .el-radio__label,
html.dark ::v-deep .el-checkbox__label {
  color: #8e9bad;
}

html.dark ::v-deep .el-radio__input.is-checked+.el-radio__label,
html.dark ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #68adff;
}

html.dark ::v-deep .el-radio__inner,
html.dark ::v-deep .el-checkbox__inner {
  border-color: #718096;
  background: #e8edf4;
}

html.dark ::v-deep .el-radio__input.is-checked .el-radio__inner,
html.dark ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #4d9cff;
  background: #4d9cff;
}

.section-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 14px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;

  &::before {
    width: 3px;
    height: 15px;
    border-radius: 3px;
    background: var(--brand);
    content: '';
  }

  .el-icon-info {
    color: var(--text-secondary);
    cursor: help;
  }
}

.section-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.section-box-item {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.item-box {
  min-width: 0;
  padding: 12px 13px;
  border: 1px solid var(--divider);
  border-radius: 9px;
  background: var(--bg-page);
  transition: border-color .16s ease, background .16s ease;

  &:focus-within {
    border-color: var(--brand-glow);
  }

  &.xh {
    flex: 0 0 150px;
  }

  &.nr {
    flex: 1 1 auto;
  }

  &.tw {
    margin-right: 0;
  }
}

.name {
  margin-bottom: 8px;
  color: var(--text-regular);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.value {
  min-width: 0;
  padding-top: 0;
  color: var(--text-regular);
  font-size: 13px;
}

.value input,
.value textarea,
.key-desc textarea,
.greet-desc textarea,
.job-desc textarea,
.tag-input,
.copy-data-box .search-input {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid var(--border-hairline);
  border-radius: 7px;
  outline: none;
  background: var(--bg-card);
  color: var(--text-primary);
  font: inherit;
  transition: border-color .16s ease, box-shadow .16s ease, background-color .16s ease;

  &::placeholder {
    color: var(--text-disabled);
  }

  &:focus {
    border-color: var(--brand);
    box-shadow: 0 0 0 3px var(--brand-glow);
  }
}

.value input,
.tag-input,
.copy-data-box .search-input {
  min-height: 36px;
  padding: 7px 10px;
}

.value textarea,
.key-desc textarea,
.greet-desc textarea,
.job-desc textarea {
  display: block;
  min-height: 74px;
  padding: 9px 10px;
  resize: vertical;
  line-height: 1.6;
}

.job-desc textarea {
  min-height: 160px;
}

.nrkey textarea {
  min-height: 74px;
}

.ages {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ages input {
  min-width: 0;
  text-align: center;
}

.unit-input {
  position: relative;
  flex: 1;
  min-width: 0;
}

.unit-input input {
  padding-right: 34px;
}

.unit-input span {
  position: absolute;
  top: 50%;
  right: 10px;
  color: var(--text-secondary);
  font-size: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}

.salary-range .salary-input {
  position: relative;
  flex: 1;
  min-width: 0;
}

.salary-range .salary-input input {
  padding-right: 28px;
}

.salary-range .salary-input span {
  position: absolute;
  top: 50%;
  right: 10px;
  color: var(--text-secondary);
  font-size: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}

.ages span,
.chatTime>span {
  flex-shrink: 0;
  color: var(--text-secondary);
}

.chatTime {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chatTime>.el-date-editor,
.chatTime>.el-time-select {
  flex: 1;
  width: 1px;
  min-width: 0;
}

::v-deep .el-radio-group,
::v-deep .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
}

::v-deep .el-radio,
::v-deep .el-checkbox {
  margin: 0 8px 4px 0;
  color: var(--text-regular);
  white-space: normal;
}

::v-deep .el-radio__label,
::v-deep .el-checkbox__label {
  padding-left: 6px;
  color: var(--text-regular);
  font-size: 12px;
}

::v-deep .el-radio__input.is-checked .el-radio__inner,
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: var(--brand);
  background: var(--brand);
}

::v-deep .el-radio__input.is-checked+.el-radio__label,
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: var(--brand);
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-date-editor .el-input__inner {
  border-color: var(--border-hairline);
  background: var(--bg-card);
  color: var(--text-primary);
}

::v-deep .el-input__inner::placeholder {
  color: var(--text-disabled);
}

::v-deep .el-input__inner:focus,
::v-deep .el-date-editor .el-input__inner:focus {
  border-color: var(--brand);
}

::v-deep .el-switch.is-checked .el-switch__core {
  border-color: var(--brand);
  background: var(--brand);
}

::v-deep .el-tag {
  margin: 0 6px 6px 0;
  border-color: var(--brand-glow);
  background: var(--brand-weak);
  color: var(--brand);
  cursor: pointer;
}

.chat .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}

.chat .switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.chat .slider {
  position: absolute;
  inset: 0;
  border-radius: 20px;
  background: var(--border-hairline);
  cursor: pointer;
  transition: background .18s ease;
}

.chat .slider::before {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--bg-card);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .18);
  content: '';
  transition: transform .18s ease;
}

.chat .switch input:checked+.slider {
  background: var(--brand);
}

.chat .switch input:checked+.slider::before {
  transform: translateX(18px);
}

.chat .switch input:focus-visible+.slider {
  outline: 2px solid var(--brand-glow);
  outline-offset: 2px;
}

.copy-data-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(100%, 440px);
  padding: 12px;
  border: 1px solid var(--divider);
  border-radius: 9px;
  background: var(--bg-page);
}

.search-input-wrapper {
  display: flex;
  gap: 8px;
}

.search-btn,
.add-btn,
.edit-btn,
.delete-btn,
.share-btn,
.save-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border-hairline);
  border-radius: 7px;
  background: var(--bg-card);
  color: var(--text-regular);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition: background .16s ease, color .16s ease, border-color .16s ease, transform .16s ease;

  &:hover {
    transform: translateY(-1px);
  }
}

.search-btn,
.add-btn,
.save-btn {
  border-color: var(--brand);
  background: var(--brand);
  color: var(--on-brand);
}

.search-btn:hover,
.add-btn:hover,
.save-btn:hover {
  border-color: var(--brand-hover);
  background: var(--brand-hover);
  color: var(--on-brand);
}

.edit-btn:hover {
  border-color: var(--brand-glow);
  background: var(--bg-active);
  color: var(--brand);
}

.delete-btn:hover {
  border-color: var(--danger);
  background: var(--danger);
  color: #fff;
}

.share-btn:hover {
  border-color: var(--success);
  color: var(--success);
}

.tag-input-area {
  min-width: 0;
}

.tag-box {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.tag-box .tag-input {
  flex: 1;
  min-width: 0;
}

.tag-item {
  display: flex;
  flex-wrap: wrap;
}

.key-box-item {
  min-width: 0;
  margin-bottom: 10px;
}

.key-box-item .item-box {
  margin-bottom: 8px;
}

.key-box-item .btn,
.btn {
  margin-top: 8px;
  text-align: right;
}

.position-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
  max-height: 220px;
  overflow: auto;
  padding: 8px;
  border: 1px solid var(--divider);
  border-radius: 9px;
  background: var(--bg-page);
}

.position-list .position-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--border-hairline);
  border-radius: 8px;
  background: var(--bg-card);
}

.position-info {
  min-width: 0;
}

.position-name {
  display: block;
  overflow: hidden;
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta-info {
  overflow: hidden;
  margin-top: 5px;
  color: var(--text-secondary);
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-btns {
  display: flex;
  flex-shrink: 0;
  gap: 6px;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  flex-shrink: 0;
  padding: 12px 22px;
  border-top: 1px solid var(--divider);
  background: var(--bg-card);
}

.footer .share-btn,
.footer .save-btn {
  min-width: 84px;
  min-height: 36px;
}

@media (max-width: 760px) {
  .dialog-mask {
    align-items: flex-end;
    padding: 0;
  }

  .edit-job {
    width: 100%;
    max-height: 94vh;
    border-radius: 16px 16px 0 0;
  }

  .job-box {
    max-height: 94vh;
  }

  .section-main {
    padding: 14px 14px 20px;
  }

  .tab-bar {
    top: 0;
    margin: -14px -14px 14px;
    padding: 9px 14px 0;
    overflow-x: auto;
  }

  .tab-item {
    min-width: 82px;
    padding: 10px 9px;
  }

  .section {
    padding: 14px;
  }

  .box-header {
    min-height: 56px;
    padding: 0 16px;
  }

  .footer {
    padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  }
}

@media (max-width: 560px) {
  .section-box-item {
    grid-template-columns: minmax(0, 1fr);
  }

  .copy-data-box {
    width: 100%;
  }

  .section-main {
    padding-right: 10px;
    padding-left: 10px;
  }

  .tab-bar {
    margin-right: -10px;
    margin-left: -10px;
    padding-right: 10px;
    padding-left: 10px;
  }

  .section {
    padding: 12px;
  }

  .chatTime {
    flex-wrap: wrap;
  }

  .chatTime>.el-date-editor,
  .chatTime>.el-time-select {
    flex: 1 1 130px;
  }

  .position-list .position-item {
    align-items: flex-start;
    flex-direction: column;
  }

  .position-list .action-btns {
    align-self: flex-end;
  }

  .footer .share-btn,
  .footer .save-btn {
    flex: 1;
  }
}
</style>
